module.exports = __webpack_public_path__ + "files/51dde61b3baa8d293fbe9b4307f0c85f.png";